import React, { useEffect, useState } from 'react';
import OptionEmoji from './OptionEmoji';
import s from '../style.module.scss';

// 星级素材：选中黄星(big_star_light) / 未选中灰星(big_star_grey)，与 PC 共用
const starLightImg = require('@/assets/images/simulation/evaluationTool/big_star_light.webp');
const starGreyImg = require('@/assets/images/simulation/evaluationTool/big_star_grey.webp');

// ---------- 选中动画参数（可配置） ----------
const STAR_POP_DURATION = 250; // 单颗星星缩放动画时长（ms）
const STAR_POP_STAGGER = 60; // 相邻星星动画错开延迟间隔（ms）

// 星级题（H5 版）：5 星点击选择 + 选中后档位胶囊（emoji + 文案），无 PC 端 hover 预览
// 升档时新点亮的星星（如已选 2 颗再点第 5 颗：第 3/4/5 颗）按顺序错开播放"从小到大"缩放动画；
// 已选中星星与其他功能不受影响（动画纯视觉，onChange 交互不变）
const StarRateRow = (props) => {
    const { question, value, onChange } = props,
        { code, title, subTitle, options = [] } = question,
        // 无选中时 value 为 0
        curScore = value || 0,
        curOption = options.find((ele) => ele.score === curScore),
        // 本轮新点亮的星星分值序列（升序）：用于逐个弹出动画
        [popScores, setPopScores] = useState([]);

    // 外部重置（弹窗重开/清空答案）时清掉动画标记
    useEffect(() => {
        if (value === undefined) {
            setPopScores([]);
        }
    }, [value]);

    const onStarClick = (score) => {
        // 升档：新点亮的星星（curScore+1 ~ score）按顺序错开播放缩放动画；降档/原分重选直接切换不动画
        setPopScores(score > curScore ? options.filter((o) => o.score > curScore && o.score <= score).map((o) => o.score) : []);
        onChange(code, score);
    };

    // 星星在本轮动画中的序号（0 起），非本轮动画星星返回 -1
    const popIndex = (score) => popScores.indexOf(score);

    return (
        <div className={s['question-row']}>
            <div className={s['question-title-wrap']}>
                <span className={s['question-title']}>{title}</span>
                {subTitle ? <span className={s['question-sub-title']}>{subTitle}</span> : null}
            </div>
            <div className={s['star-rate-wrap']}>
                <div className={s['star-list']}>
                    {options.map((option, index) => {
                        const active = curScore >= option?.score,
                            idx = popIndex(option?.score),
                            popping = idx > -1;
                        return (
                            <img
                                key={index}
                                className={`${s['star-item']} ${popping ? s['star-item-pop'] : ''}`}
                                // 时长/延迟走内联 style：与顶部可配置常量联动
                                style={popping ? { animationDuration: `${STAR_POP_DURATION}ms`, animationDelay: `${idx * STAR_POP_STAGGER}ms` } : undefined}
                                src={active ? starLightImg : starGreyImg}
                                alt=""
                                onClick={() => onStarClick(option?.score)}
                            />
                        );
                    })}
                </div>
                {curOption ? (
                    // key 绑定档位分值：换档时 key 变化重播挂载动画，实现"切换丝滑感"而非瞬变
                    <div key={curOption?.score} className={s['option-capsule']}>
                        <OptionEmoji emoji={curOption?.emoji} />
                        <span>{curOption?.label}</span>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default StarRateRow;
